<template>
  <div class="apply-record-detail" v-if="record">
    <div class="module content">
      <div class="status">
        <span class="name" :class="[ 'status' + record.statusCss ]">{{ record.statusText }}</span>
        <span class="date">{{ record.createdDate && record.createdDate.format("yyyy-MM-dd hh:mm:ss") }}</span>
      </div>
      <div class="img">
        <img v-for="(src, index) in record.imgs" :src="src" :key="index" @click="preview(record.imgs, index)" />
      </div>
      <div class="remark">
        {{ record.desc }}
      </div>
      <div class="oth">
        <div class="item">
          <span class="name">手机品牌</span>
          <span class="txt">{{ record.brand }}</span>
        </div>
        <div class="item">
          <span class="name">序列号</span>
          <span class="txt">{{ record.serial }}</span>
        </div>
        <div class="item">
          <span class="name">IMEI码</span>
          <span class="txt">{{ record.imei }}</span>
        </div>
      </div>
    </div>
    <div class="module address">
      <h3 class="line">服务地址</h3>
      <div class="oth">
        <div class="item">
          <span class="name">省市区</span>
          <span class="txt">{{ record.areaText }}</span>
        </div>
        <div class="item">
          <span class="name">详细地址</span>
          <span class="txt">{{ record.address }}</span>
        </div>
      </div>
    </div>
    <div v-if="record.status == 30" class="module audit">
      <h3>审核未通过原因</h3>
      <div class="remark">{{ this.record.reason }}</div>
    </div>
    <div class="foot">
      <y-button v-if="(record.statusMask & 4) == 4" class="btn" @click="apply(record)">重新提交</y-button>
      <y-button v-if="(record.statusMask & 2) == 2" class="btn" @click="cancel(record)">取消申请</y-button>
    </div>
  </div>
</template>


<script>
import { Dialog } from 'vant';
import { ImagePreview } from "vant";
import { login } from "../../scripts/auth";
import { httpOpen } from "../../scripts/network";

export default {
  name: "ApplyRecord",
   data() {
    return {
      id: this.$route.params.id,
      record: null,
    };
  },
  created() {
    this.loadRecord();
  },
  methods: {
    async loadRecord() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/ServiceApplyDetail", {
          type: "post",
          body: {
            SysNo: this.id,
          },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast(ret.Message || "加载失败，请稍后重试");
        } else {
          let detail = ret.Data || {};
          let item = {
            id: detail.SysNo,
            cardSysNo: detail.WfcOrderSysNo,
            status: detail.AuditStatus,
            imgs: detail.AppendDixList.map((i) => i.AppendixContent),
            desc: detail.CustomerMessage,
            createdDate: detail.CreatedDate && new Date(detail.CreatedDate + "+08:00"),
            brand: detail.BrandName,
            serial: detail.SerialNumber,
            imei: detail.IMEICode,
            reason: detail.AuditFailReason,
            address: detail.CustomerStreetAddress
          };

          if (detail.CustomerArea) {
            item.areaText = detail.CustomerArea.ProvinceName + detail.CustomerArea.CityName + detail.CustomerArea.DistrictName;
          }

          this.statusMapper(item);
          this.record = item;
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    statusMapper(record) {
      // 未审核 = 10,审核通过 = 20,审核不通过 = 30, 已取消 = 40
      switch (parseInt(record.status)) {
        case 10:
          record.statusText = "审核中";
          record.statusMask = 1 | 2;
          record.statusCss = 1;
          break;
        case 20:
          record.statusText = "审核通过";
          record.statusMask = 1;
          record.statusCss = 3;
          break;
        case 30:
          record.statusText = "审核未通过";
          record.statusMask = 1 | 4;
          record.statusCss = 2;
          break;
        case 40:
          record.statusText = "已取消";
          record.statusMask = 1;
          record.statusCss = 1;
        break;
        default:
          record.statusText = record.status;
          record.statusMask = 0;
          record.statusCss = 1;
          break;
      }
    },
    apply(record) {
      this.$router.push({
        name: "ServiceForm",
        params: {
          id: record.cardSysNo,
        },
        query: {
          applyId : record.id
        }
      });
    },
    async doCancel(record){
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/ServiceApplyCancel", {
          type: "post",
          body: {
            SysNo: record.id,
          },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast(ret.Message || "取消失败");
        } else {
          this.$toast("取消成功");
          
          record.status = 40;
          this.statusMapper(record); // 已取消
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    async cancel(record) {
      Dialog.confirm({
        message: '当前申请正在审核中 是否确认取消？'
      }).then(()=>{
        this.doCancel(record);
      }).catch(()=> {
      });
    },
    preview(imgs,index){
      ImagePreview({
        images: imgs, 
        showIndex: true,
        loop: true,
        startPosition: index
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .apply-record-detail{
    padding: 12px;
    min-height: 100vh;
    background-color: #f4f4f4;
    box-sizing: border-box;
    .module{
      background-color: #fff;
      border-radius: 6px;
      padding: 14px 10px;
      &:not(:first-child){
        margin-top: 10px;
      }
      &.content{
        .status{
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          align-items: center;
          .name{
            font-size: 14px;
            border-radius: 10px;
            display: inline-block;
            padding: 3px 8px;
            &.status1{
              color: #785c27;
              background-color: #FFF5F5;
            }
            &.status2{
              color: #BD5B5B;
              background-color: #EAFFF7;
            }
            &.status3{
              color: #49A36D;
              background-color: #EBEBEB;
            }
          }
          .date{
            font-size: 14px;
            color: rgba(0,0,0,0.85);
          }
        }
        .img{
          display: grid;
          grid-template-columns: 22% 22% 22% 22%;
          grid-column-gap: 4%;
          grid-row-gap: 10px;
          >img{
            width: 100%;
            height: 75px;
            object-fit: cover;
          }
        }
        .remark{
          margin-top: 23px;
          font-size: 16px;
          color: rgba(0,0,0,0.85);
          padding-bottom: 14px;
          border-bottom: 1px solid #f0f0f0;
          font-weight: 600;
        }
        .oth{
          margin-top: 14px;
          font-size: 12px;
          color: rgba(0,0,0,0.85);
          .item{
            display: flex;
            &:not(:first-child){
              margin-top: 9px;
            }
            .name{
              width: 52px;
            }
            .txt{
              margin-left: 12px;
            }
          }
        }
      }
      &.audit{
        h3{
          margin: 0;
          padding: 0;
          font-size: 14px;
          color: rgba(0,0,0,0.85);
        }
        .remark{
          font-size: 14px;
          color: rgba(0,0,0,0.85);
          margin-top: 8px;
        }
      }
      &.address{
        h3{
          margin: 0 0 14px 0;
          padding: 0;
          font-size: 14px;
          color: #000;
          &.line{
            padding-bottom: 7px;
            border-bottom: 1px solid #f0f0f0;
          }
        }
        .item{
          display: flex;
          &:not(:first-child){
            margin-top: 9px;
          }
          .name{
            width: 80px;
            color: #666666;
            font-size: 14px;
          }
          .txt{
            margin-left: 12px;
            color: #000;
            font-size: 14px;
          }
        }
      }
    }
    .foot{
      position: fixed;
      display: flex;
      bottom: 0;
      left: 0;
      right: 0;
      height: 47px;
      background-color: #fff;
      align-items: center;
      z-index: 10;
      box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.11);
      display: flex;
      justify-content: flex-end;
      .btn{
        width: 85px;
        margin-right: 18px;
        background: #EBEBEB;
        border: 1px solid #D9D9D9;
        font-size: 12px;
        color: #000;
        height: 32px;
        &.primary{
          color: #FFE0A5;
          background: linear-gradient(118deg, #383838 8%, #2F2F2F 84%);
        }
      }
    }
  }
</style>